import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui';
import { DesignerState } from './DesignerFlow';
interface Props {
  data: DesignerState;
  updateData: (data: Partial<DesignerState>) => void;
  onNext: () => void;
  onBack: () => void;
}
export function Step3Experience({
  data,
  updateData,
  onNext,
  onBack
}: Props) {
  const categories = [{
    id: 'audienceType',
    label: 'Audience type',
    options: ['Executives', 'Managers', 'Sales team', 'Full company', 'Department team', 'Client group', 'Association members', 'Mixed group']
  }, {
    id: 'energyLevel',
    label: 'Energy level',
    options: ['Calm', 'Balanced', 'Active', 'High-energy']
  }, {
    id: 'format',
    label: 'Preferred format',
    options: ['Structured', 'Flexible', 'Social', 'Reflective', 'Workshop-heavy', 'Experience-heavy', 'Balanced']
  }, {
    id: 'comfortLevel',
    label: 'Comfort level',
    desc: 'How much personal sharing should be included?',
    options: ['Light', 'Moderate', 'Deep', 'Optional only']
  }, {
    id: 'foodAlcohol',
    label: 'Food and alcohol preference',
    options: ['Standard', 'Wellness-focused', 'Optional alcohol', 'No alcohol', 'Dietary-sensitive', 'Not sure']
  }];
  const isValid = data.audienceType && data.energyLevel && data.format && data.comfortLevel && data.foodAlcohol;
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12" data-id="element-2524">
      <h1 className="text-3xl font-bold text-brand-navy mb-8" data-id="element-2525">
        What kind of experience do you want attendees to have?
      </h1>

      <div className="space-y-10" data-id="element-2526">
        {categories.map(category => <div key={category.id} data-id="element-2527">
            <div className="mb-3" data-id="element-2528">
              <h3 className="text-sm font-semibold text-slate-700" data-id="element-2529">
                {category.label}
              </h3>
              {category.desc && <p className="text-xs text-slate-500 mt-1" data-id="element-2530">{category.desc}</p>}
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-2531">
              {category.options.map(option => {
            const isSelected = data[category.id as keyof DesignerState] === option;
            return <button key={option} onClick={() => updateData({
              [category.id]: option
            })} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border ${isSelected ? 'bg-brand-navy text-white border-brand-navy shadow-md' : 'bg-white text-slate-600 border-slate-200 hover:border-brand-teal hover:text-brand-teal'}`} data-id="element-2532">
                    {option}
                  </button>;
          })}
            </div>
          </div>)}
      </div>

      <div className="mt-10 pt-6 border-t border-slate-100 flex justify-between items-center" data-id="element-2533">
        <Button variant="ghost" onClick={onBack} data-id="element-2534">
          Back
        </Button>
        <Button variant="primary" size="lg" onClick={onNext} disabled={!isValid} data-id="element-2535">
          Continue
        </Button>
      </div>
    </motion.div>;
}